/**
 * CSRF Initializer Component
 * Fetches CSRF token on app mount
 */

import { useEffect } from 'react';
import { apiClient } from '@/lib/api/client';

export function CsrfInitializer() {
  useEffect(() => {
    // Fetch CSRF token on mount
    const initCsrf = async () => {
      try {
        await apiClient.fetchCsrfToken();
      } catch (error) {
        console.error('Failed to initialize CSRF protection:', error);
        // Don't block app if CSRF fetch fails
        // The backend will reject requests without valid tokens
      }
    };

    initCsrf();
  }, []);

  return null; // This component doesn't render anything
}
